import React, { Component } from "react";
import { Button, ModalDialog } from "@culturehq/components";

import BadgeIcon from "components/display/BadgeIcon";

import ChqModalDialog from "components/common/ChqModalDialog";
import SurveyItem from "./SurveyItem";

class SurveyPreview extends Component {
  state = { open: false };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { children, survey: { surveyItems, points, title } } = this.props;
    const { open } = this.state;

    return (
      <>
        {children(this.handleOpen)}
        {open && (
          <ChqModalDialog entrance="zoomIn" className="TakeSurveyModal" onClose={this.handleClose}>
            <ModalDialog.Heading onClose={this.handleClose}>
              {title}
            </ModalDialog.Heading>
            <ModalDialog.Body>
              <div className="clearfix">
                <BadgeIcon badge="widget_survey" points={points} size="medium" />
                <div className="SurveyPage">
                  <div className="col-sm-12">
                    {surveyItems.map((surveyItem, index) => (
                      <SurveyItem
                        key={surveyItem.id}
                        itemNumber={index + 1}
                        surveyItem={surveyItem}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <Button onClick={this.handleClose} primary>
                Close preview
              </Button>
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

export default SurveyPreview;
